import { useContext } from 'react';
import { UserContext } from 'libs/contexts';
import { isArray } from '@/libs/utils';

const SelfOperatedOrganization = () => {
  const userInfo = useContext(UserContext);
  if (!userInfo) return false;
  const { organizationCode, selfOrgCode } = userInfo;
  return isArray(selfOrgCode) && selfOrgCode.includes(organizationCode);
};

export default SelfOperatedOrganization;
